import { RichSelect } from "@components/forms/selectWithDescription";
import { ISelectOptionDTO } from "@hooks/dtos/forms/ISelectDTO";
import { IProfitTypeDTO } from "@hooks/dtos/profit/IProfitTypeDTO";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { api } from "@service/api";
import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { RaffleProfitTotalOverview } from "../overview/total";
import { RaffleProfitProfitedOverview } from "../overview/profited";
import { RaffleProfitPartnerOverview } from "../overview/partner";

interface IProps {
  raffleTypeId?: number;
  ticketAmount?: number;
  ticketPrice?: number;
  rewardPrice?: number;
  paymentMethod?: number;
  onChange?: (profit: IProfitTypeDTO | undefined) => void;
}

export function RaffleCreateCampaignProfitChoose({
  raffleTypeId,
  ticketAmount,
  ticketPrice,
  rewardPrice,
  paymentMethod = 1,
  onChange,
}: IProps) {
  // --- Default Variables --- //
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // --- Importants Use States --- //
  const status = `a`;
  const [profit, setProfit] = useState<IProfitTypeDTO>();
  const [profits, setProfits] = useState<IProfitTypeDTO[]>([]);
  const [profitOptions, setProfitOptions] = useState<ISelectOptionDTO[]>([]);
  const [selectedProfitId, setSelectedProfitId] = useState<number>(0);

  const getRaffleProfitTypes = async () => {
    try {
      const params = `status=${status}&raffleTypeId=${raffleTypeId}`;
      const response = await api.get(`/raffle/profitTypes?${params}`);

      setProfits(response.data);
    } catch (error: any) {
      pushToastify({
        message: error?.response?.data?.message,
        type: "error",
        theme: "dark",
      });
    }
  };

  const profitComponents: { [key: number]: JSX.Element | null } = {
    1: (
      <RaffleProfitTotalOverview
        profit={profit || ({} as IProfitTypeDTO)}
        paymentMethod={paymentMethod}
        ticketAmount={ticketAmount ?? 0}
        ticketPrice={ticketPrice ?? 0}
        rewardPrice={rewardPrice ?? 0}
      />
    ),
    2: (
      <RaffleProfitProfitedOverview
        profit={profit || ({} as IProfitTypeDTO)}
        paymentMethod={paymentMethod}
        ticketAmount={ticketAmount ?? 0}
        ticketPrice={ticketPrice ?? 0}
        rewardPrice={rewardPrice ?? 0}
      />
    ),
    3: (
      <RaffleProfitPartnerOverview
        profit={profit || ({} as IProfitTypeDTO)}
        paymentMethod={paymentMethod}
        ticketAmount={ticketAmount ?? 0}
        ticketPrice={ticketPrice ?? 0}
        rewardPrice={rewardPrice ?? 0}
      />
    ),
  };

  useEffect(() => {
    if (profits.length > 0) return;
    getRaffleProfitTypes();
  }, []);

  useEffect(() => {
    if (!selectedProfitId || profits.length < 1) {
      if (onChange) onChange(undefined);
      return;
    }

    const _profit = profits.find((p) => p.id === selectedProfitId);
    if (!_profit) return;
    setProfit(_profit);

    if (onChange) onChange(_profit);
  }, [selectedProfitId]);

  useEffect(() => {
    const options: ISelectOptionDTO[] = [
      {
        value: "",
        name: "Selecione uma opção...",
        description: "Selecione uma opção para ver as expectativas de ganhos.",
      },
      ...profits.map((profit) => ({
        value: profit.id,
        name: profit.name,
        description: profit.description_short,
      })),
    ];

    setProfitOptions(options);
  }, [profits]);

  return (
    <>
      {/* The Search Result */}
      {profits.length > 0 ? (
        <>
          <RichSelect
            label="Tipo de Lucro"
            options={profitOptions}
            value={selectedProfitId}
            onChange={(value) => {
              setSelectedProfitId(Number(value));
            }}
            placeholder="Escolha o tipo de lucro"
          />

          {profitComponents[selectedProfitId] || null}
        </>
      ) : (
        <div className="alert alert-warning mt-3">
          <FiSearch className="me-2" />
          {"Não foi encontrado nenhum tipo de ganho para esta rifa/campanha. Tente novamente mais tarde."}
        </div>
      )}
    </>
  );
}
